import { render, staticRenderFns } from "./BrowseView.vue?vue&type=template&id=8ecd472e"
import script from "./BrowseView.vue?vue&type=script&lang=js"
export * from "./BrowseView.vue?vue&type=script&lang=js"
import style0 from "./BrowseView.vue?vue&type=style&index=0&id=8ecd472e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports